import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IImgMediaDto } from 'src/app/core/dtos/interfaces/i-img-media-dto';
import { compareArrays } from '../utils/array-utils';

type WithBannerImageFormSectionType = {
  _initBannerImage(bannerImage: IImgMediaDto): void;
  _initBannerImageValueChanges(
    getPreviousBannerImageValue: () => IImgMediaDto | null
  ): void;
  _buildBannerImage(): IImgMediaDto;
};

type BannerImageFormSerectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: {
    BANNER_IMAGE: () => string;
  };
  destroy$: Subject<boolean>;
};

export function WithBannerImageFormSection<
  TBase extends Constructor<BannerImageFormSerectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithBannerImageFormSectionType;
  prototype: WithBannerImageFormSectionType;
} & TBase {
  return class WithBannerImageFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initBannerImage(bannerImage: IImgMediaDto): void {
      let bannerImageControl = this.form.get(
        this.FORM_PATHS.BANNER_IMAGE()
      ) as FormArray<FormControl<IImgMediaDto>>;
      if (bannerImage) bannerImageControl.push(new FormControl(bannerImage));
    }

    _initBannerImageValueChanges(
      getPreviousBannerImageValue: () => IImgMediaDto | null
    ): void {
      this.form
        .get(this.FORM_PATHS.BANNER_IMAGE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, [getPreviousBannerImageValue()])) {
              this.form.get(this.FORM_PATHS.BANNER_IMAGE()).markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.BANNER_IMAGE()).markAsDirty();
            }
          },
        });
    }

    _buildBannerImage(): IImgMediaDto {
      return this.form.get(this.FORM_PATHS.BANNER_IMAGE()).value
        ? this.form.get(this.FORM_PATHS.BANNER_IMAGE()).value[0]
        : null;
    }
  };
}
